document.addEventListener('DOMContentLoaded', () => {
  const chipsContainer = document.querySelector('.fr-chips');
  if (!chipsContainer) return;

  const chips = Array.from(chipsContainer.querySelectorAll('.fr-chip'));
  const items = Array.from(document.querySelectorAll('[data-fr-item]'));

  // Desde 2026-09-18 el grid de gratuitos va PARTIDO en dos (antes y después
  // de la franja de pago), así que hay que recogerlos todos. Se excluye el
  // grid de la propia franja: sus cards no son filtrables por categoría.
  const grids = Array.from(document.querySelectorAll('.resource-grid'))
    .filter((g) => !g.classList.contains('paid-row__grid'));

  // La franja de pago se oculta mientras hay un filtro activo: intercalar
  // productos de pago dentro de un resultado filtrado confunde, y el reparto
  // "N filas y luego la franja" deja de tener sentido al cambiar el número
  // de cards visibles.
  const paidRow = document.querySelector('[data-fr-paid-row]');

  // Con el grid partido en dos, al filtrar cada mitad arrancaba su PROPIA
  // fila: "shapes" (5 printables) salía 2 + 3 con un hueco a la derecha de
  // la primera fila, en vez de 4 + 1. Para evitarlo, mientras hay un filtro
  // activo todas las cards se juntan en el primer grid, y al volver a "All"
  // cada una regresa a su sitio. Se guarda el hogar original de cada card
  // ANTES de mover nada, porque después ya no se puede deducir.
  const hogar = new Map(items.map((item) => [item, item.parentElement]));
  const primerGrid = grids[0];

  const juntarEnUno = () => {
    if (!primerGrid) return;
    items.forEach((item) => {
      if (item.parentElement !== primerGrid) primerGrid.appendChild(item);
    });
  };

  const devolverACasa = () => {
    items.forEach((item) => {
      const casa = hogar.get(item);
      if (casa && item.parentElement !== casa) casa.appendChild(item);
    });
  };

  chipsContainer.addEventListener('click', (event) => {
    const chip = event.target.closest('.fr-chip');
    if (!chip) return;

    chips.forEach((c) => {
      c.classList.toggle('is-active', c === chip);
      c.setAttribute('aria-selected', c === chip ? 'true' : 'false');
    });

    const selected = chip.dataset.frChip;
    const esTodo = selected === 'all';

    // El orden importa: primero se recolocan las cards y luego se decide qué
    // grid se oculta, o se ocultaría un grid que acaba de recibir cards.
    if (esTodo) devolverACasa();
    else juntarEnUno();

    // "Popular" no es una categoría: filtra por el campo `badge` del
    // printable (2026-09-18). Así un mismo printable aparece en "Popular" y
    // en su categoría real, y el cliente lo controla desde el admin poniendo
    // o quitando el badge, sin tocar código.
    const esPopular = selected === 'popular';

    let visible = 0;
    items.forEach((item) => {
      const card = item.querySelector('[data-fr-category]');
      const category = card ? card.dataset.frCategory : '';
      const badge = card ? (card.dataset.frBadge || '') : '';
      const show = esTodo || (esPopular ? badge === 'popular' : category === selected);
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (paidRow) paidRow.hidden = !esTodo;

    // Un grid cuyas cards estén todas ocultas se esconde también: si no, deja
    // su margen y abre un hueco. Con el filtro activo el segundo grid queda
    // vacío (todo se movió al primero), así que esto lo retira del flujo.
    // Categoría sin printables: se ocultan todos y no se muestra ningún
    // mensaje (el cliente pidió quitarlo).
    grids.forEach((grid) => {
      const algunaVisible = Array.from(grid.querySelectorAll('[data-fr-item]'))
        .some((item) => !item.hidden);
      grid.hidden = !algunaVisible;
    });

    if (visible === 0) grids.forEach((grid) => { grid.hidden = true; });
  });
});
